module.exports = __webpack_public_path__ + "static/media/icon-5.9fa33f12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/icon-5.png
// module id = 2557
// module chunks = 0